module.exports = __webpack_public_path__ + "static/img/logo16.4ffc0a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo16.png
// module id = cAMF
// module chunks = 1